// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"360":"3c54ef78","366":"2c94e45b"}[chunkId] + ".js";
};